import { useEffect, useState } from "react";
import { APIActionOnAssessmentInvitation } from "utils/api";

import "./AssignmentPage.scss";
import { useTranslation } from "react-i18next";
import AssignmentDescription from "./components/AssignmentDescription";
import { AssessmentReservationStatus, useAssignmentsContext } from "components/AssignmentsProvider";
import "../ErrorLoginPage/ErrorLoginPage.scss";
import AssessmentTutorialModal from "./components/AssessmentTutorialModal";
import ErrorAssignementPage from "views/ErrorAssignementPage";
import { add, isWithinInterval, parseISO, sub } from "date-fns";

// errors
const ERROR_API = "ooops-something-went-wrong-please-try-again";

export default function AssignmentPage(props: any) {
  const { t } = useTranslation();
  const { selectedAssessment, isLoggedIn, lab, reservation, refreshReservation, refreshAssessmentInvitation, handleOpenAuthModal }: any = useAssignmentsContext();

  const [isTutorialModalOpen, setIsTutorialModalOpen] = useState(false);

  // schedule lab instance
  // returns the error if any
  const handleScheduleInstance = (date, openTutorialModal = false) => {
    setShowStartNow(false);
    return APIActionOnAssessmentInvitation(selectedAssessment.id, "start-now", {})
      .then((res) => res.data)
      .then(() => {
        refreshAssessmentInvitation();
        refreshReservation();
        return;
      })
      .catch((err) => {
        return t(ERROR_API);
      });
  };

  /**
 * SCHEDULING BUTTON GROUP
 */
  const [isLoading, setIsLoading] = useState(false);
  const [submissionError, setSubmissionError] = useState(null);
  const [showError, setShowError] = useState(false);
  const [showCooking, setShowCooking] = useState(false);
  const [showBooked, setShowBooked] = useState(false);
  const [showStartNow, setShowStartNow] = useState(false);
  const [showReady, setShowReady] = useState(false);

  useEffect(() => {
    setShowError(false);
    setSubmissionError(null);
    setShowCooking(false);
    setShowBooked(false);
    setShowReady(false);
    setShowStartNow(false);
    if (reservation) {
      setIsLoading(false);
      switch (reservation.status) {
        case AssessmentReservationStatus.FAILED:
          setShowError(true);
          setSubmissionError(t("reservation-failed-contact-support"))
          break;
        case AssessmentReservationStatus.CREATED:
        case AssessmentReservationStatus.SCHEDULED:
          setIsTutorialModalOpen(true);
          if (isWithinInterval(new Date(), {
            // if before 15 minutes of reservation date and at the end of lab, show cooking
            start: sub(parseISO(reservation.date), { minutes: 15 }),
            end: add(parseISO(reservation.date), { minutes: lab.duration }),
          })) {
            setShowCooking(true);
          } else {
            setShowBooked(true);
          }
          break;
        case AssessmentReservationStatus.PROVISIONING:
          setShowCooking(true);
          setIsTutorialModalOpen(true);
          // if (isWithinInterval(new Date(), {
          //   start: sub(parseISO(reservation.date), { minutes: 15 }),
          //   end: add(parseISO(reservation.date), { minutes: lab.duration }),
          // })) {
          break;
        case AssessmentReservationStatus.READY:
          setShowReady(true);
          break;
        case AssessmentReservationStatus.CANCELLED:
          setShowError(true);
          setSubmissionError("Assessment was cancelled.")
          break;
        case AssessmentReservationStatus.TERMINATED:
        case AssessmentReservationStatus.TERMINATING:
        case AssessmentReservationStatus.ENDED:
          setShowError(true);
          setSubmissionError("Assessment has ended. Thank you for your participation.")
          break;
        default:
          setShowError(true);
          setSubmissionError("Something went wrong, please try again.")
          break;
      }
    } else {
      if (isLoggedIn) {
        setShowStartNow(true);
        setIsLoading(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reservation, isLoggedIn]);


  if (!selectedAssessment || !lab) {
    return (
      <div className="mx-0 mt-[50px] md:mt-[120px]">
        <ErrorAssignementPage errorType="not_found" />
      </div>
    )
  }
  return (
    <main className="mx-0 mt-[50px] md:mt-[120px]">
      <AssessmentTutorialModal
        open={isTutorialModalOpen}
        handleClose={() => { }}
        reservation={reservation}
        showCooking={showCooking}
        showBooked={showBooked}
        showReady={showReady}
      />
      {/* {!(isReservationLoaded) ? (
        <div className="mx-0 mt-[50px] md:mt-[120px]">
          <LoadingImage className="!flex"></LoadingImage>
        </div>
      ) : ( */}
      <AssignmentDescription
        handleOpenAuthModal={handleOpenAuthModal}
        handleScheduleInstance={handleScheduleInstance}
        reservation={reservation}
        refreshReservation={refreshReservation}
        lab={lab}
        showError={showError}
        showCooking={showCooking}
        showBooked={showBooked}
        showReady={showReady}
        showLogin={!isLoggedIn}
        showStartNow={showStartNow}
        submissionError={submissionError}
        isLoading={isLoading}
        setSubmissionError={setSubmissionError}
        setIsLoading={setIsLoading}
      ></AssignmentDescription>
      {/* )} */}
    </main>
  );
}
